<template>
  <div v-if="voci && voci.length" class="sottostati">
    <div
      v-for="voce in voci"
      :key="voce.id || voce.numero || voce.stato"
      class="sottostato"
      :class="{ 'sottostato--attivo': eAttivo(voce) }"
    >
      <span class="sottostato__ramo" aria-hidden="true"></span>
      <span class="sottostato__scheda">
        <span class="sottostato__punto" aria-hidden="true"></span>
        <span class="sottostato__testo">
          <span class="sottostato__etichetta">sottostato di preventivo</span>
          <span class="sottostato__nome">{{ voce.stato }}</span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SottostatiTimeline",
  props: {
    voci: {
      type: Array,
      default: () => [],
    },
    corrente: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    eAttivo(voce) {
      const id = voce?.id ?? voce?.numero;
      return Number(id) === Number(this.corrente);
    },
  },
};
</script>

<style scoped>
.sottostati {
  margin: 4px 0 2px;
  max-width: 100%;
}

.sottostato {
  display: flex;
  align-items: stretch;
}

.sottostato__ramo {
  width: 16px;
  border-left: 2px solid #c5cdd8;
  border-bottom: 2px solid #c5cdd8;
  border-bottom-left-radius: 10px;
  margin: -2px 8px 12px 0;
  flex: none;
}

.sottostato__scheda {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0 2px;
  padding: 6px 10px;
  background: #f4f6f8;
  border-radius: 8px;
}

.sottostato__punto {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 2px solid #98a2b3;
  background: #fff;
  flex: none;
}

.sottostato__testo {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sottostato__etichetta {
  font-size: 10px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #98a2b3;
}

.sottostato__nome {
  font-size: 13px;
  line-height: 1.2;
  color: #475467;
}

.sottostato--attivo .sottostato__ramo {
  border-color: #2196f3;
}

.sottostato--attivo .sottostato__scheda {
  background: #e3f2fd;
}

.sottostato--attivo .sottostato__punto {
  background: #2196f3;
  border-color: #2196f3;
}

.sottostato--attivo .sottostato__etichetta,
.sottostato--attivo .sottostato__nome {
  color: #1565c0;
}

.sottostato--attivo .sottostato__nome {
  font-weight: 700;
}
</style>
